export const FORM_VALIDATIONS = {
    REQUIRED: "Este campo es obligatorio",
    WRONG_FORMAT: "Formato erroneo",
    SIZE: {
        EIGTH: "Debe tener al menos 8 caracteres"
    }
}
